import APIError from '../APIError';

class UpdateDataError extends APIError {
  constructor(code, details = null) {
    super(code, 'UpdateDataError', details);
  }
}

export default UpdateDataError;
